<template>
    <div class="composition">
        <div class="create-paper-box">
            <el-button type="primary" @click="createPaperButton">
                <i class="el-icon-plus" style="margin-right: 5px"></i>创建组卷
            </el-button>
        </div>
        <div class="scroll-content">
            <el-scrollbar style="height: 100%;">
                <TableList :tableColumnConfig="tableConfig" :tableData="tableData" :toggleSwitch="toggleSwitch">
                    <template #default="{item}">
                        <div>
                            <el-link type="success" :underline="false" @click="editPaper(item)">编辑</el-link>
                            <el-link type="danger" :underline="false" @click="deletePaper(item)">删除</el-link>
                        </div>
                    </template>
                </TableList>
            </el-scrollbar>
        </div>
        <div class="paging-box">
            <el-pagination
                @current-change="pagingChange"
                :current-page.sync="getPaperTableParams.page"
                :page-size="getPaperTableParams.pageSize"
                layout="prev, pager, next, jumper"
                :total="totalCount"
            >
            </el-pagination>
        </div>
        <Dialog ref="operatePaperPaper" title="组卷设置" :confirmHandler="submitForm">
            <el-form :model="operatePaperParams" :rules="rules" ref="ruleForm" label-width="110px" class="form-box">
                <el-form-item label="名称" prop="nickname">
                    <el-input
                        type="text"
                        v-model="operatePaperParams.nickname"
                        placeholder="请输入试卷名称"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="选择理论试卷" prop="theoryPaper">
                    <div class="content flex">
                        <el-select v-model="operatePaperParams.theoryPaper[0]" placeholder="请选择理论试卷">
                            <el-option
                                v-for="item in TheoryOptions[0]"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                        <div class="score-box flex">
                            <span class="score-text">分值占比</span>
                            <el-select v-model="operatePaperParams.theoryPaper[1]" placeholder="请选择理论试卷">
                                <el-option
                                    v-for="item in TheoryOptions[1]"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="选择实操试卷" prop="actualPaper">
                    <div class="content flex">
                        <el-select v-model="operatePaperParams.actualPaper[0]" placeholder="请选择实操试卷">
                            <el-option
                                v-for="item in actualOptions[0]"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                        <div class="score-box flex">
                            <span class="score-text">分值占比</span>
                            <el-select v-model="operatePaperParams.actualPaper[1]" placeholder="请选择实操试卷">
                                <el-option
                                    v-for="item in actualOptions[1]"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="分类" prop="cate">
                    <el-select v-model="operatePaperParams.cate" placeholder="请选择分类">
                        <el-option v-for="item in cateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </Dialog>
        <Dialog ref="deletePaper" title="删除试卷" :confirmHandler="confirmDeletePaper">
            <div>删除后不可恢复</div>
        </Dialog>
    </div>
</template>

<script>
import TableList from "components/admin/identifyCenterManage/common/TableList";
import Dialog from "components/admin/identifyCenterManage/common/Dialog";
import { getIdentifyCenterSetPaperList, deleteIdentifyCenterSetPaper } from "@/utils/apis";

export default {
    name: "composition",
    data() {
        let validatePaper = (rule, value, callback) => {
            if (!value[0]) {
                callback(new Error("请选择试卷"));
            } else if (!value[1]) {
                callback(new Error("请设置分值"));
            } else {
                callback();
            }
        };
        return {
            cateOptions: [],
            TheoryOptions: [[], []],
            actualOptions: [[], []],
            tableData: [{ name: "123", person: "user", level: 1, cate: "分类", status: true }],
            tableConfig: [
                { label: "组卷名称", prop: "name" },
                { label: "创建人", prop: "person" },
                { label: "难度", prop: "level" },
                { label: "分类", prop: "cate" },
                { label: "状态", prop: "status", isSwitch: true },
                { label: "操作", align: "center", width: 200 },
            ],
            operatePaperParams: {
                nickname: "",
                theoryPaper: ["", 0],
                actualPaper: ["", 0],
                cate: "",
            },
            rules: {
                nickname: [{ required: true, message: "请输入账号名称", trigger: "blur" }],
                theoryPaper: [{ validator: validatePaper, trigger: "blur" }],
                actualPaper: [{ validator: validatePaper, trigger: "blur" }],
                cate: [{ required: true, message: "请选择分类", trigger: "blur" }],
            },

            //
            getPaperTableParams: {
                paging: "1",
                page: 1,
                pageSize: 10,
            },
            totalCount: 100,
        };
    },
    components: {
        TableList,
        Dialog,
    },
    mounted() {
        // this.getPaperTableData();
    },
    watch: {
        "getPaperTableParams.page"() {
            this.getTheoryList();
        },
    },
    methods: {
        async getPaperTableData() {
            let res = await getIdentifyCenterSetPaperList();
            if (res.code == 200) {
                this.tableData = res.data.list;
                this.totalCount = res.data.total;
            } else {
                this.$message.error(res.msg);
            }
        },
        createPaperButton() {
            this.$refs.operatePaperPaper.open();
        },
        editPaper(item) {},
        deletePaper(item) {
            this.$refs.deletePaper.open();
        },
        confirmDeletePaper() {},
        toggleSwitch(item) {
            item.status = !item.status;
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.createPaper();
                } else {
                    return false;
                }
            });
        },
        pagingChange(val) {
            this.getPaperTableParams.page = val;
        },
        createPaper() {},
    },
};
</script>

<style scoped lang="scss">
.composition {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    height: 100%;
    .create-paper-box {
        text-align: end;
        margin-bottom: 20px;
    }
    .scroll-content {
        flex: 1;
        overflow: hidden;
    }
    .paging-box {
        padding: 20px 0;
        text-align: center;
    }
    .form-box {
        .el-form-item {
            display: flex;
            align-items: center;
        }
        ::v-deep .el-form-item__label {
            margin-bottom: 0;
            margin-right: 20px;
        }
        ::v-deep .el-form-item__content {
            flex: 1;
            margin-left: 0 !important;
        }
        .score-text {
            margin: 0 10px;
            white-space: nowrap;
        }
    }
}
::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
}
</style>
